import {media, styled} from '@styles';

export const Wrapper = styled.div`
	position: relative;
	z-index: 0;
	margin: 0.5rem;
	text-align: center;
	max-height: 29rem;
	min-height: 16rem;
	padding-bottom: 0.5rem;
	transition: 0.3s;
	border-radius: 10px;
	outline: none;
	${media.smallScreen`
  min-height: 10rem;

  `}
	&:hover {
		color: ${(props) => props.theme.colors.lightFont};
		box-shadow: 1px 3px 6px #dcdcdc;
	}
`;

export const DetailsWrapper = styled.div`
	padding: 0 2px;
`;

export const Title = styled.h4`
	font-family: ${(props) => props.theme.typography.baseFontFamily} !important;
	text-transform: capitalize;
	font-size: 14px;
	text-align: left;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	overflow: hidden;
`;

export const Merchant = styled.p`
	color: ${(props) => props.theme.colors.pink};
	font-family: ${(props) =>
		props.theme.typography.secondaryFontFamily} !important;
	font-size: 14px;
	text-transform: uppercase;
	margin-top: 0.5rem;
	text-align: left;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	overflow: hidden;
`;

export const Category = styled.p`
	color: #a4a4a4;
	font-size: 12px;
	text-transform: uppercase;
	text-align: left;
	margin: -0.5rem 0 0 0;
`;

export const Price = styled.p`
	color: ${(props) => props.theme.colors.baseFont};
	> span {
		font-family: ${(props) => props.theme.typography.secondaryFontFamily};
	}
	text-align: left;
	font-size: ${(props) => props.theme.typography.smallFontSize};
	${media.smallScreen`
    font-size:14px;
  `}
`;

export const PriceWrapper = styled.div``;

export const Image = styled.div`
	position: relative;
	> a {
		user-select: none;
		-webkit-user-drag: none;
		> img {
			width: 100%;
			height: auto;
			max-width: 100%;
			border-radius: 5px;
			object-fit: cover;
			user-select: none;
			-webkit-user-drag: none;
		}
	}
`;

export const LocationWrapper = styled.div`
	* {
		color: ${(props) => props.theme.colors.lightFont} !important;
	}
`;
